
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getSupplementalPay = async () => {
  return await get<ApiResponse<any[]>>("/supplementalpay").then((res)=>{
      return res
    })
};

 